import React, { useState, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    MenuItem,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import Swal from 'sweetalert2';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

import ContentMarketingService from '../../services/contentMarketing.service';

import '../../styles/style.scss';

export const ContentMarketingSectionScreen = (props) => {

    const swalCustomButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn custom-confirm-cancel-btn',
          cancelButton: 'btn custom-cancel-btn me-3'
        },
        buttonsStyling: false
      });

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const dispatch = useDispatch();
    const history = useHistory();

    const [isChangingPassword, setIsChangingPassword] = useState(false);
    const [isLoadingSectionData, setIsLoadingSectionData] = useState(true);

    const [contentSection, setContentSection] = useState(['']);

    const [expanded, setExpanded] = useState('panel1');

    const regexCode = /^[A-zÀ-ú\d\-_\s]+$/i;

    const validationSchemaCreate = Yup.object().shape({
        section: Yup.string().required('nombre requerido.')
                    .matches(regexCode, "Solo se admiten letras y numero.")
    });

    const validationSchemaDelete = Yup.object().shape({
        section: Yup.string().required('nombre requerido.')
    });

    const validationSchemaUpdate = Yup.object().shape({
        section: Yup.string().required('nombre requerido.')
            .matches(regexCode, "Solo se admiten letras y numero."),
        id: Yup.string().required('nombre requerido.')
    });

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchemaCreate)
    });

    const {
        register: registerDelete,
        handleSubmit: handleSubmitDelete,
        formState: { errors: errorsDelete }
    } = useForm({
        resolver: yupResolver(validationSchemaDelete)
    });

    const {
        register: registerUpdate,
        handleSubmit: handleSubmitUpdate,
        formState: { errors: errorsUpdate }
    } = useForm({
        resolver: yupResolver(validationSchemaUpdate)
    });

    useEffect(() => {
        getSections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    /**
     * Obtiene el arreglo de secciones disponibles
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const getSections = () => {
        ContentMarketingService.getSections().then((response)=>{
            setContentSection(response);
            setIsLoadingSectionData(false);
        }).catch((error)=>{
            setContentSection([]);
            setIsLoadingSectionData(false);
            if(sessionDifference > Number(tokenExpired)){
                sesionExpired(dispatch, history);
              } else{
                  actionErrorConnection(error, 
                      (error.response && error.response.data) ?'No existen Secciones':'Error al recuperar secciones');
              }
        });
    }

    /**
     * Regresa a la pantalla de contenidos
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const handleCancel = () => {
        props.history.push('/administration/content/marketing');
        window.location.reload();
    };
    
    /**
     * Cambia el estado del panel seleccionado
     * @param {*} panel identificador del elemento a expandir
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    /**
     * Realiza la slicitud para crear sección
     * @param {*} data - Información del formulario de crear sección
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const onSubmit = (data) => {
        setIsChangingPassword(true);
        ContentMarketingService.getCreateSection(data.section).then(()=>{
            getSections();
            setIsChangingPassword(false);
            Swal.fire({
                icon: 'success',
                title: 'Sección creada.',
                showConfirmButton: false,
                timer: 1500
              });
        })
        .catch((error)=>{
            setIsChangingPassword(false);
            if(error.response && error.response.status === 401){
                if(sessionDifference > Number(tokenExpired)){
                    sesionExpired(dispatch, history);
                }
            }else{
                actionErrorConnection(error, 'Error al crear sección.');
            }
        });

    };

    /**
     * Realiza la slicitud para eliminar sección
     * @param {*} data - Información del formulario de eliminar sección
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const onSubmitDelete = (data) => {
        setIsChangingPassword(true);
        console.log(data.section);
        console.log(contentSection[0].id.toString());
        const fileName = contentSection.filter(dataSection=>dataSection.id.toString()===data.section);
        console.log(fileName);
        swalCustomButtons.fire({
            title: 'Eliminar',
            html: `<span>Esta acción eliminará permanentemente el archivo </span> <span class="text-title-delete-file"> ${fileName.length>0 && fileName[0].name}</span>`,
            icon: 'warning',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
                ContentMarketingService.deleteSection(data.section).then(()=>{
                    setIsChangingPassword(false);
                    Swal.fire({
                        icon: 'success',
                        title: 'Sección Eliminada.',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    window.location.reload();  
                })
                .catch((error)=>{
                    setIsChangingPassword(false);
                    if(error.response && error.response.status === 401){
                        if(sessionDifference > Number(tokenExpired)){
                            sesionExpired(dispatch, history);
                        }
                    }else{
                        actionErrorConnection(error, 'Error al eliminar sección.');
                    }
                });
            } else{
                setIsChangingPassword(false);
            }
          });
    };

    /**
     * Realiza la slicitud para actualizar sección
     * @param {*} data - Información del formulario de actualizar sección
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021
     */
    const onSubmitUpdate = (data) => {
        setIsChangingPassword(true);
        ContentMarketingService.getUpdateSection(data).then(()=>{
            getSections();
            setIsChangingPassword(false);
            Swal.fire({
                icon: 'success',
                title: 'Sección actualizada.',
                showConfirmButton: false,
                timer: 1500
              });
        })
        .catch((error)=>{
            setIsChangingPassword(false);
            if(error.response && error.response.status === 401){
                if(sessionDifference > Number(tokenExpired)){
                    sesionExpired(dispatch, history);
                }
            }else{
                actionErrorConnection(error, 'Error al actualizar sección.');
            }
        });

    };


    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="row flex-nowrap m-0 p-0 ">
                    <div className="col-auto col-md-3 col-xl-2 d-none d-sm-block p-0">
                        <SidebarMenu/>
                    </div>
                    <div className="col p-0 me-1 ms-1">
                        <NavTopMenu />
                        <div className="container ps-3 pe-3 container-size">
                            <div className="row base-container ">
                                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                                    <div className="row">
                                        <div className="col-10 text-title">
                                            <span>Contenido </span>
                                            <i className="fas fa-angle-right me-2 ms-2"></i>
                                            <span>Avisos</span>
                                            <i className="fas fa-angle-right me-2 ms-2"></i>
                                            <span>Secciones</span>
                                        </div>
                                        <div className="col-2 text-title">
                                            <div className="w-100 d-flex justify-content-end">
                                                <Tooltip title="Regresar" placement="top-start" arrow>
                                                    <button className="btn custom-btn-icons" 
                                                    type="button" 
                                                    onClick={handleCancel}
                                                    >
                                                        <i className="fas fa-angle-left custom-icon-return"></i>
                                                    </button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                                    <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                                            
                                                <div className="border-text-menu-title pe-5">
                                                    <Typography>
                                                        <span className="text-subtitle" >Nueva sección</span>
                                                    </Typography>
                                                </div>
                                            
                                        </AccordionSummary>
                                        <AccordionDetails>
                                                <div className="container p-0">    
                                                    <form>
                                                        <div className="row d-flex justify-content-end">
                                                            <div className="col-md-9 pt-2 pb-2">
                                                                <div className="row">
                                                                    <div className="col-md-6 col-lg-4 mt-2 mb-2">
                                                                        <TextField
                                                                            required
                                                                            className="w-100"
                                                                            id="section"
                                                                            name="section"
                                                                            label="nombre sección"
                                                                            type="text"
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            size="small"
                                                                            disabled={isChangingPassword}
                                                                            {...register('section')}
                                                                            error={errors.section ? true : false}
                                                                        />
                                                                        <Typography variant="inherit" color="error">
                                                                            {errors.section?.message}
                                                                        </Typography>
                                                                    </div>
                                                                    <div className="col-md-12 col-lg-8 d-flex justify-content-end">
                                                                        <div>
                                                                            <button  
                                                                                className="btn custom-btn pt-2 pb-2 ps-3 pe-3 mt-1 mb-1" 
                                                                                onClick={handleSubmit(onSubmit)}
                                                                                disabled={isChangingPassword}
                                                                            >
                                                                                <span className="me-2">Crear</span>
                                                                                {
                                                                                    isChangingPassword 
                                                                                    ? <i className="fas fa-spinner fa-spin"></i>
                                                                                    : <i className="fas fa-save"></i>
                                                                                } 
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div> 
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')} disabled={isLoadingSectionData}>
                                        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" expandIcon={<ExpandMoreIcon />}>
                                        
                                            <div className="border-text-menu-title pe-5">
                                                <Typography>
                                                    <span className="text-subtitle" >Eliminar sección</span>
                                                    {isLoadingSectionData && <i className="fas fa-spinner fa-spin ms-2"></i>}
                                                </Typography>
                                            </div>
                                        
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="container p-0">
                                                <form>
                                                    <div className="row d-flex justify-content-end">
                                                        <div className="col-md-9 pt-5 pb-2">
                                                            <div className="row">
                                                                <div className="col-md-6 col-lg-4 mt-2 mb-2">
                                                                
                                                                    <TextField
                                                                        select
                                                                        required
                                                                        id="section"
                                                                        name="section"
                                                                        label="Sección"
                                                                        variant="outlined"
                                                                        size="small" 
                                                                        fullWidth
                                                                        defaultValue=""
                                                                        {...registerDelete('section', { required: true })}
                                                                        >
                                                                            <MenuItem value="">Seleccionar sección</MenuItem>
                                                                        {contentSection.map((option, id) => (
                                                                            <MenuItem key={id} value={option.id}>
                                                                            {option.name}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </TextField>
                                                                    <Typography variant="inherit" color="error">
                                                                        {errorsDelete.section?.message}
                                                                    </Typography>
                                                                </div>
                                                                <div className="col-md-12 col-lg-8 d-flex justify-content-end">
                                                                    <div>
                                                                        <button  
                                                                            className="btn custom-delete-btn pt-2 pb-2 ps-3 pe-3 mt-1 mb-1" 
                                                                            onClick={handleSubmitDelete(onSubmitDelete)}
                                                                            disabled={isChangingPassword}
                                                                        >
                                                                            <span className="me-2">Eliminar</span>
                                                                            {
                                                                                isChangingPassword 
                                                                                ? <i className="fas fa-spinner fa-spin"></i>
                                                                                : <i className="fas fa-trash"></i>
                                                                            } 
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div> 
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')} disabled={isLoadingSectionData}>
                                        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" expandIcon={<ExpandMoreIcon />}>
                                        
                                            <div className="border-text-menu-title pe-5">
                                                <Typography>
                                                    <span className="text-subtitle" >Actualizar sección</span>
                                                    {isLoadingSectionData && <i className="fas fa-spinner fa-spin ms-2"></i>}
                                                </Typography>
                                            </div>
                                        
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="container p-0">
                                                <form>
                                                    <div className="row d-flex justify-content-end">
                                                        <div className="col-md-9 pt-5 pb-2">
                                                            <div className="row">
                                                                <div className="col-md-6 col-lg-4 mt-2 mb-2">
                                                                    <TextField
                                                                        select
                                                                        required
                                                                        id="id"
                                                                        name="id"
                                                                        label="Sección"
                                                                        variant="outlined"
                                                                        size="small" 
                                                                        fullWidth
                                                                        defaultValue=""
                                                                        {...registerUpdate('id', { required: true })}
                                                                        >
                                                                            <MenuItem value="">Seleccionar sección</MenuItem>
                                                                        {contentSection.map((optionUpdate, id) => (
                                                                            <MenuItem key={id} value={optionUpdate.id}>
                                                                            {optionUpdate.name}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </TextField>
                                                                    <Typography variant="inherit" color="error">
                                                                        {errorsUpdate.id?.message}
                                                                    </Typography>
                                                                </div>
                                                                <div className="col-md-6 col-lg-4 mt-2 mb-2">
                                                                        <TextField
                                                                            required
                                                                            className="w-100"
                                                                            id="section"
                                                                            name="section"
                                                                            label="Nuevo nombre"
                                                                            type="text"
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            size="small"
                                                                            disabled={isChangingPassword}
                                                                            {...registerUpdate('section')}
                                                                            error={errorsUpdate.section ? true : false}
                                                                        />
                                                                        <Typography variant="inherit" color="error">
                                                                            {errorsUpdate.section?.message}
                                                                        </Typography>
                                                                    </div>
                                                                <div className="col-md-12 col-lg-4 d-flex justify-content-end">
                                                                    <div>
                                                                        <button  
                                                                            className="btn custom-btn pt-2 pb-2 ps-3 pe-3 mt-1 mb-1" 
                                                                            onClick={handleSubmitUpdate(onSubmitUpdate)}
                                                                            disabled={isChangingPassword}
                                                                        >
                                                                            <span className="me-2">Actualizar</span>
                                                                            {
                                                                                isChangingPassword 
                                                                                ? <i className="fas fa-spinner fa-spin"></i>
                                                                                : <i className="fas fa-edit"></i>
                                                                            } 
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div> 
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}

ContentMarketingSectionScreen.propTypes = {
    history: PropTypes.object
  }